import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminUserAdminEditComponent } from "./admin-user-admin-edit.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [AdminUserAdminEditComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzModalModule,
    NzButtonModule,
    FormsModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzSelectModule,
    ReactiveFormsModule,
  ],
  exports: [AdminUserAdminEditComponent],
})
export class AdminUserAdminEditModule {}
